import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const awardSchema = z.object({
  title: z.string().min(3),
  year: z.number().min(2010),

  type: identitySchema,
  awardedFor: identitySchema,
  institution: identitySchema,
  conference: identitySchema.nullable(),
  contribution: identitySchema,
  activity: identitySchema,

  authors: z.array(authorSchema).min(1),
});

export const defaultAwardValues: DefaultValues<AwardSchema> = {
  title: '',
  authors: [],
  conference: null,
};

export type AwardSchema = z.infer<typeof awardSchema>;
